module.exports = "<div class=\"ubg-tab-dialog-dialog-item\" [ngClass]=\"getItemClass()\">\n  <ng-content></ng-content>\n</div>"